module.exports = __webpack_public_path__ + "static/bellbanking2.f27c4f87.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellbanking2.jpeg
// module id = 1252
// module chunks = 35783957827783